/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */

import { createLogic } from 'redux-logic';

import {
  RECEIVED_DELETE_GRANT_VIEW_ACCESS_USER,
  RECEIVED_UPDATE_VIEW_RELATIONSHIPS,
  RECEIVED_ADD_VIEW_RELATIONSHIPS
} from 'state/grantViewAccess/GrantViewAccessActions';
import { dispatchBusinessEvent } from 'state/preferences/PreferencesActions';
import { addToast } from 'state/toast/ToastActions';
import { analyticsActionSuccess } from 'state/analytics/AnalyticsActions';

const UpdateViewAccessLogic = createLogic({
  type: [
    RECEIVED_DELETE_GRANT_VIEW_ACCESS_USER,
    RECEIVED_UPDATE_VIEW_RELATIONSHIPS,
    RECEIVED_ADD_VIEW_RELATIONSHIPS
  ],

  process({ action }, dispatch, done) {
    const { viewRelationships } = action;
    // dispatch user message
    dispatch(addToast(true, 'Changes Saved'));

    if (action.type === RECEIVED_DELETE_GRANT_VIEW_ACCESS_USER) {
      dispatch(analyticsActionSuccess('ProfPref', 'GrantViewAccessUserDelete'));
    }
    else if (action.type === RECEIVED_UPDATE_VIEW_RELATIONSHIPS) {
      dispatch(analyticsActionSuccess('ProfPref', 'GrantViewAccessEdit'));
    }
    else {
      dispatch(analyticsActionSuccess('ProfPref', 'GrantViewAccessUserAdd'));
    }

    const businessEvent = {
      viewRelationships: viewRelationships
    };

    dispatch(dispatchBusinessEvent(businessEvent));

    done();
  }
});

export default UpdateViewAccessLogic;
